<template>
    <div class="min_box">
        <div class="top">
        <div class="flex">
          <div class="item"><span>应购买数:</span>{{summary.total_automated_marketing_num}}</div>
          <div class="item"><span>实际剩余数:</span>{{summary.rest_num}}</div>
        </div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"  >

        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"

            // site_use_count
    const columns = [

        {
            title: "客户名称",
            key: "company",
            dataIndex: "company",
        },
        {
            title: "购买封数",
            key: "automated_marketing_num",
          dataIndex: "automated_marketing_num",
        },
        {
            title:"使用封数",
            key: "automated_marketing_use_num",
            dataIndex: "automated_marketing_use_num",
        }

    ];
    export default {
        name: 'index',
        data() {
            return {
                loading: true,
                data: [],
                columns,
                name:"",
              summary:{},
              pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
              },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/AutomatedMarketing"; //设置左侧导航2-2 active
        },
        computed: {
            hasData() {
                return this.data.length > 0;
            },
        },
        methods: {
            getList(page) {
                API.service.GET_LIST({page: page || 1}).then(res => {
                    this.data = res.data.data.data
                  this.pagination.total=res.data.data.total
                  this.pagination.pageSize=res.data.data.per_page
                  this.pagination.current=res.data.data.current_page
                    this.loading = false
                })
            },
          getSummary(){
            API.service.GET_SUMMARY().then(res=>{
            this.summary=res.data.data
            })
          },
        },
        mounted() {
            this.getList()
          this.getSummary()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }

    .min_box{width:500px}
    .top{margin-bottom: 20px;}
    .num{color: #1890ff;}
    .top .flex  {

    }
    .top .flex .item{box-shadow: 0 2px 12px 0 rgb(0 ,0 ,0, .1); padding: 10px 16px;line-height:50px;
      box-sizing: border-box;
      width: 100%;
      margin-bottom:0px;width: 48%}
    .top .flex .item span{font-weight: bold;padding-right: 10px}
</style>
